import { render, staticRenderFns } from "./old-Step-3.vue?vue&type=template&id=061b1c60&scoped=true&"
import script from "./old-Step-3.vue?vue&type=script&lang=js&"
export * from "./old-Step-3.vue?vue&type=script&lang=js&"
import style0 from "./old-Step-3.vue?vue&type=style&index=0&id=061b1c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b1c60",
  null
  
)

export default component.exports